import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface UpdateUserProfileInterface {
  currentPassword: string;
  newPassword: string;
}

export const useUpdateUserProfile = () => {
  const mutate = useMutation(({ currentPassword, newPassword }: UpdateUserProfileInterface) => {
    return postAPI('/enterprise-api/update_enterprise_password', {
      currentPassword,
      newPassword,
    });
  });

  return mutate;
};

export default useUpdateUserProfile;
